import { AxiosResponse } from 'axios';

// An upload answers with the operation it started in its Location header,
// which ends in `/operation/{id}`.
export const getOperationId = ({ headers }: Pick<AxiosResponse, 'headers'>) => {
  const { location } = headers;
  return typeof location === 'string'
    ? /\/operation\/([^/?#]+)$/.exec(location)?.[1]
    : undefined;
};
